import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { httpOptions } from 'src/app/global/global_variables';
import { ReceivingResponse } from 'src/app/models/ReceivingResponse';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReceivingService {

  constructor(private http: HttpClient) { }
  apiLink = environment.apiLink;

  getRecDocksData(): Observable<ReceivingResponse> {
    return this.http.get<ReceivingResponse>(`${this.apiLink}/Rec/Docks`, httpOptions)
  }

  getRecDocksDataView(): Observable<ReceivingResponse> {
    return this.http.get<ReceivingResponse>(`${this.apiLink}/View/Rec/Docks`, httpOptions)
  }
}
